import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { AuthContext } from "@/providers/authProvider";
import { ToastContainer } from "react-toastify";
import { Suspense, lazy } from 'react';

const TanstackRouterDevTools =
  "cmp-pjt-prd" === import.meta.env.VITE_FIREBASE_PROJECT_ID
    ? () => null
    : lazy(() =>
        import("@tanstack/router-devtools").then((res) => ({
          default: res.TanStackRouterDevtools,
        }))
      );

const RootComponent = () => {
  return (
    <>
      <Outlet />
      <Suspense>
        <TanstackRouterDevTools />
      </Suspense>
      <ToastContainer />
    </>
  );
};

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
  auth: AuthContext;
}>()({
  component: RootComponent,
});
